<template>
  <v-app id="app_outlet_types">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">CREATE & VIEW OUTLET TYPES</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">establish & access outlet types tailored to your
            needs.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="true" rounded="lg">
        <v-card-text class="custom_tool_bar_style d-flex align-center">
          <div class="d-flex align-center flex-grow-1">
            <p class="custom_page_component_main_title ma-0">OUTLET TYPE DATA LIST</p>
          </div>
          <div class="d-flex align-center">
            <v-btn class="custom_measurement_btn" variant="outlined" @click="openDialog" v-if="permissions.write">
              &nbsp;&nbsp;CREATE NEW OUTLET TYPE
            </v-btn>
            <v-btn class="custom_pdf_btn ml-4" variant="outlined" @click="exportPDF">
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>
            <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </div>
        </v-card-text>

        <v-divider class="my-2" style="height: 2px;"></v-divider>

        <!-- Number of outlet types -->
        <v-row align="center" justify="space-between">
          <!-- Left Side: Outlet Type Card -->
          <v-col cols="auto">
            <v-card elevation="1" class="pa-3 d-flex align-center">
              <div>
                <h1 class="custom_number_of_outlet_types_btn">{{ totalOutletTypes }}</h1>
                <p class="font-weight-medium">NUMBER OF TYPES</p>
              </div>
            </v-card>
          </v-col>

          <!-- Right Side: Search Bar -->
          <v-col cols="12" md="4">
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" clearable hide-details
                          label="Search" placeholder="Search Outlet Types" variant="outlined"
                          class="custom_input_field_color" density="comfortable"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-2" style="height: 2px;"></v-divider>

        <v-data-table
            :headers="headers"
            :items="outletTypes"
            :search="search"
            :items-per-page="itemsPerPage"
            class="elevation-1"
        >
          <template v-slot:[`item.description`]="{ item }">
              <span v-if="item.description && item.description.length" v-html="getSanitizedHTML(item.description)">
              </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu transition="slide-x-transition" id="app_product_list">
              <template v-slot:activator="{ props }">
                <v-btn class="custom_btn_primary" variant="flat" size="large" v-bind="props">
                  ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-if="permissions.write" @click="editOutletType(item)">
                  <v-list-item-title class="custom_font_color_edit">EDIT</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                  <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>

        <v-pagination
            v-model="page"
            :length="totalPages"
            @input="changePage"
            class="my-4"
        ></v-pagination>

      </v-card>
      <v-dialog v-model="dialog" max-height="700" id="app_outlet_type_dialog" max-width="600">
        <v-card rounded="md" style="overflow:hidden !important;">
          <div class="pa-4">
            <!-- Dialog Title -->
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">{{ dialogTitle }}</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="closeDialog" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <!-- Form Content -->
            <v-card-text>
              <v-form ref="form">
                <v-text-field
                    v-model="outletTypeName"
                    label="Outlet Type Name*"
                    placeholder="Type outlet type name here"
                    variant="outlined"
                    required
                    @input="updateUnitCount"
                >
                  <template v-slot:append-inner>
                    <span class="text-caption">{{ unitCount }}/20</span>
                  </template>
                </v-text-field>

                <v-text>Outlet Type Description</v-text>
                <v-card class="mt-5" elevation="1" border="sm opacity-1" rounded="lg" max-height="280" min-height="280">
                  <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>
                  <v-divider></v-divider>
                  <Editor aria-placeholder="Type Here..." v-model="valueHtml" :defaultConfig="editorConfig" :mode="mode"
                          @onCreated="handleCreated" @onChange="handleEditorChange"/>

                </v-card>
                <v-card-text class="text-caption text-right">
                  Word Count: {{ charCount }}/300
                </v-card-text>
              </v-form>
            </v-card-text>

            <!-- Action Buttons -->
            <v-card-actions class="d-flex justify-end">
              <v-btn color="primary" variant="flat" @click="saveOutletType">{{ dialogButtonText }}</v-btn>
              <v-btn variant="outlined" @click="closeDialog">CANCEL</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="delete_dialog" max-height="500" max-width="500" persistent id="app_outlet_type_delete">
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE OUTLET TYPE</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="delete_dialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this OUTLET TYPE?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This outlet type will be deleted immediately. Once deleted, it can no longer be used for any purpose.
                  <span style="color: blue;">
                    Further, these modules are also related to the following others, so please read and confirm before deleting this.
                  </span>
                </p>

                <v-timeline align="start" density="compact">
                  <v-timeline-item>
                    <template v-slot:opposite></template>
                    <div>
                      <div class="text-h6">related area 01</div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                        labore et dolore magna aliqua.
                      </p>
                    </div>
                  </v-timeline-item>

                  <v-timeline-item>
                    <template v-slot:opposite></template>
                    <div>
                      <div class="text-h6">related area 02</div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                        labore et dolore magna aliqua.
                      </p>
                    </div>
                  </v-timeline-item>
                </v-timeline>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4 ">
                  <v-btn class="custom_btn_primary" @click="deleteOutletType">DELETE</v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="delete_dialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" location="top-right" outlined>
        {{ snackbarMessage }}

        <template v-slot:action="{ attrs }">
          <v-btn icon v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
                  :top="snackAlert.snackBarTop" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import "@wangeditor/editor/dist/css/style.css";
import {i18nChangeLanguage} from "@wangeditor/editor";
import axios from "axios";

i18nChangeLanguage("en");
// import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import {getPermissions} from "@/plugins/permissions";
import {Editor, Toolbar} from "@wangeditor/editor-for-vue";
import DOMPurify from "dompurify";

export default {
  name: 'OutletTypeList',
  components: {
    Editor,
    Toolbar,
  },
  data() {
    return {
      charCount: 0,
      unitCount: 0,
      charLimit: 300,
      permissions: {},
      search: "",
      page: 1,
      itemsPerPage: 10,
      dialog: false,
      dialogTitle: 'CREATE OUTLET TYPE',
      dialogButtonText: 'CREATE',
      outletTypeName: '',
      selectedOutletTypeId: null,
      description: '',
      delete_dialog: false,
      headers: [
        {text: "OUTLET TYPE", value: "outlet_name", title: 'OUTLET TYPE', sortable: true},
        {text: "DESCRIPTION", value: "description", title: 'DESCRIPTION', sortable: true},
        {text: "ACTIONS", value: "actions", title: 'ACTIONS', sortable: true}
      ],
      outletTypes: [],
      editingOutletType: null,
      snackbar: false,
      snackbarColor: '',
      snackbarMessage: '',
      centerLoading: false,
      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarRight: false,
        snackBarTop: true,
      },
      // WANG Editor
      editorRef: null,
      valueHtml: '<p></p>',
      toolbarConfig: {toolbarKeys: ['bold', 'italic', 'underline', 'through']},
      editorConfig: {placeholder: 'Type description here...'},
      mode: 'default', // or 'simple'
    };
  },
  computed: {
    totalOutletTypes() {
      return this.outletTypes.length;
    },
    totalPages() {
      return Math.ceil(this.outletTypes.length / this.itemsPerPage);
    }
  },
  methods: {

    getSanitizedHTML(html) {
      return DOMPurify.sanitize(html);
    },


    // Calculate character count
    calculateCharCount(html) {
      if (!html) return 0;
      const text = html.replace(/<[^>]+>/g, ''); // Remove HTML tags
      return text.length; // Count characters
    },

    // Handle editor content change
    handleEditorChange() {
      const text = this.valueHtml.replace(/<[^>]+>/g, ''); // Remove HTML tags
      if (text.length > this.charLimit) {
        this.showSnackbar(`Maximum limit of ${this.charLimit} characters reached.`, 'error');
        // this.valueHtml = text.substring(0, this.charLimit); // Truncate input
      }
      this.charCount = this.calculateCharCount(this.valueHtml);
    },

    updateUnitCount() {
      this.unitCount = this.outletTypeName.length;
      if (this.unitCount > 20) {
        this.showSnackbar(`Maximum limit of 20 characters reached.`, 'error');
        // this.valueHtml = text.substring(0, this.charLimit); // Truncate input
      }
    },

    handleCreated(editor) {
      this.editorRef = editor;
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    confirmDelete(item) {
      console.log('Deleting item:', item.id);
      this.selectedOutletTypeId = item.id;
      this.delete_dialog = true;
    },

    stripHtmlTags(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },

    fetchOutletTypes() {
      const token = localStorage.getItem("token");
      console.log("token is ", token);

      axios.post(
          "/api/get/outletType",
          {},
          {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
      )
          .then(response => {
            const data = response.data;
            this.outletTypes = data;
          })
          .catch(error => {
            console.error("Error fetching outlet types:", error);
          });
    },

    openDialog() {
      this.dialogTitle = 'CREATE OUTLET TYPE';
      this.dialogButtonText = 'CREATE';
      this.outletTypeName = '';
      this.valueHtml = '<p></p>';
      this.editingOutletType = null;
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },

    async saveOutletType() {
      if (!this.outletTypeName) {
        alert("Outlet Type Name is required!");
        return;
      }

      // Validate character count
      if (this.charCount > this.charLimit) {
        this.showSnackbar(`Description must be ${this.charLimit} characters or less.`, 'error');
        return;
      }

      if (this.outletTypeName.length > 20) {
        this.showSnackbar('Unit must be 20 words or less.', 'error');
        return;
      }
      const textOnlyRegex = /^[A-Za-z\s]+$/;
      if (!textOnlyRegex.test(this.measurementName) || !textOnlyRegex.test(this.unit)) {
        this.showSnackbar('Only letters and spaces are allowed for outlet Type!', 'error');
        return;
      }

      const outletType = {
        outlet_name: this.outletTypeName,
        description: this.valueHtml
      };

      const token = localStorage.getItem("token");

      if (this.editingOutletType) {
        console.log("the edit id is ", this.editingOutletType.id);
        try {
          const response = await axios.post(
              `/api/update/outletType/${this.editingOutletType.id}`,
              outletType,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              }
          );

          if (response.status === 200) {
            const index = this.outletTypes.findIndex(m => m.id === this.editingOutletType.id);
            this.outletTypes.splice(index, 1, response.data);
            this.closeDialog();
            this.showSnackbar('Outlet type updated successfully', 'success');
          } else {
            this.showSnackbar('Failed to update outlet type', 'error');
          }
        } catch (error) {
          console.error("Error updating outlet type:", error);
          this.showSnackbar('Failed to update outlet type', 'error');
        }
      } else {
        try {
          const response = await axios.post(
              "/api/create/outletType",
              outletType,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              }
          );

          this.outletTypes.push(response.data);
          this.closeDialog();
          this.showSnackbar('Outlet type created successfully', 'success');
        } catch (error) {
          console.error("Error creating outlet type:", error);
          this.showSnackbar('Failed to create outlet type', 'error');
        }
      }
    },

    editOutletType(item) {
      this.dialogTitle = 'EDIT OUTLET TYPE';
      this.dialogButtonText = 'UPDATE';
      this.outletTypeName = item.outlet_name;
      this.valueHtml = item.description;
      this.editingOutletType = item;
      this.dialog = true;
    },

    async deleteOutletType() {
      try {
        const token = localStorage.getItem("token");
        const outletTypeId = this.selectedOutletTypeId;

        const response = await axios.post(
            `/api/delete/outletType/${outletTypeId}`,
            {},
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
        );

        if (response.status === 200) {
          this.outletTypes = this.outletTypes.filter(m => m.id !== this.selectedOutletTypeId);
          this.delete_dialog = false;
          this.showSnackbar('Outlet type deleted successfully', 'success');
        } else {
          this.showSnackbar('Failed to delete outlet type', 'error');
        }
      } catch (error) {
        console.error("Error deleting outlet type:", error);
        this.showSnackbar('Failed to delete outlet type', 'error');
      }
    },

    exportPDF() {
      console.log("Exporting to PDF");
      const fileName = 'outlet_types.pdf';
      const file_type = 'pdf';
      this.logDocumentDownload(fileName, file_type);
      this.showSnackbar('PDF export initiated', 'info');
    },

    exportExcel() {
      console.log("Exporting to Excel");
      const fileName = 'outlet_types.xlsx';
      const file_type = 'excel';
      this.logDocumentDownload(fileName, file_type);
      this.showSnackbar('Excel export initiated', 'info');
    },

    logDocumentDownload(fileName, fileType) {
      // Implement your download logging logic here
      console.log(`Downloading ${fileType} file: ${fileName}`);
    },

    changePage(newPage) {
      this.page = newPage;
    },

    backPageRoute() {
      console.log("Going back");
      // Implement your back navigation logic here
    }
  },
  mounted() {
    const dashboardId = 2; // Adjust this based on your permissions setup
    this.permissions = getPermissions(dashboardId);
    this.fetchOutletTypes();
  },
  beforeUnmount() {
    if (this.editorRef) {
      this.editorRef.destroy();
    }
  }
}
</script>

<style scoped>
/* Add any custom styles here */
.custom_number_of_outlet_types_btn {
  font-size: 2.5rem;
  font-weight: bold;
  color: #1976D2;
}

.custom_outlet_type_btn {
  background-color: #1976D2;
  color: white;
}

.custom_outlet_type_btn:hover {
  background-color: #1565C0;
}
</style>